import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import { toast } from 'react-toastify';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import Add from '../../../../modal/Settings/Package_Management/Item_Sub_Category/AddItemSubCat';
import Edit from '../../../../modal/Settings/Package_Management/Item_Sub_Category/EditItemSubCat';
import EditItemSubCat from '../../../../modal/Settings/Package_Management/Item_Sub_Category/EditItemSubCat';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { Row, Col, Tab, Nav, Dropdown } from "react-bootstrap";

const ItemSubCategory = () => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const tableRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [modalType, setModalType] = useState("");
    const [page, setPage] = useState(1); //pagination
    const [totalPages, setTotalPages] = useState(1); //pagination
    const [searchTerm, setSearchTerm] = useState(''); //pagination
    const [perPage, setPerPage] = useState(25); //pagination
    const [itemSubCategories, setItemSubCategories] = useState([]);
    const [selectedSubcategoryId, setSelectedSubcategoryId] = useState(null);
    const [editModalShow, setEditModalShow] = useState(false);
    const [currentItemId, setCurrentItemSubtId] = useState(null);
    const [hasFetched, setHasFetched] = useState(false);
    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchCategories();
    }
    const [totalEntries, setTotalEntries] = useState(0);

    const fetchCategories = async (pageNumber = 1, perPageCount = 25, search = '') => {
        console.log('Fetching with:', { pageNumber, perPageCount, search });

        try {
            const response = await axios.get(`${baseURL}/item-subcategories`, {
                params: {
                    page: pageNumber,
                    per_page: perPageCount,
                    search: search,
                },
            });
            const data = response.data;
            setItemSubCategories(data.data || []);
            setTotalPages(data.pagination?.last_page || 1);
            setTotalEntries(data.pagination?.total || 0);
            setHasFetched(true);
        } catch (error) {
            console.error('Error fetching item categories:', error);
        }
    };

    useEffect(() => {
        fetchCategories(page, perPage, searchTerm);
    }, [page, searchTerm, perPage]);

    const navigate = useNavigate();
    const location = useLocation();

    const handleModalToggle = () => {
        setModalType("Add");
        setOpen(true);
    };

    const handleModalToggle_Edit = () => {
        setModalType("Edit");  // Set the modal type to "Add"
        setOpen(true);
    };

    const handleModalItemSub_Edit = (itemSubId) => {
        setEditModalShow(true);
        setCurrentItemSubtId(itemSubId);
    };

    const DeleteModal = (id, name, fetchCategories) => {
        swal.fire({

            html: `
                    <div class="alert alert-danger px-2 py-2" role="alert">
                        <strong>OOPS! </strong> You're about to lose one Sub Category
                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                    <p class="text-center"><b>${name}</b></p>  
                    <div class="text-center">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                            <defs>
                                <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#5987dd"/>
                                    <stop offset=".118" stop-color="#638bd6"/>
                                    <stop offset=".316" stop-color="#7d98c3"/>
                                    <stop offset=".572" stop-color="#a8aba3"/>
                                    <stop offset=".871" stop-color="#e3c678"/>
                                    <stop offset="1" stop-color="#ffd364"/>
                                </radialGradient>
                                <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                            </defs>
                            <g id="_27-feel_bad" data-name="27-feel bad">
                                <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                                <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                                <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                                <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                                <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                                <circle class="cls-6" cx="34" cy="22" r="1"/>
                                <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                                <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                                <circle class="cls-6" cx="16" cy="22" r="1"/>
                                <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                                <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                                <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                                <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                                <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                                <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                                <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                                <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                                <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                                <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                                <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                            </g>
                        </svg>
                    </div>
                `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                // 🔥 Call DELETE API
                axios.delete(`${baseURL}/item-subcategories/${id}`)
                    .then(() => {
                        swal.fire({
                            title: 'Item Sub Category Deleted!',
                            text: `${name} has been marked as deleted.`,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            customClass: {
                                title: 'fs-6',
                                confirmButton: 'btn btn-sm btn-primary',
                            },
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then(() => {
                            softRefresh(); // or fetchCategories() to refresh your list
                        });
                    })
                    .catch((error) => {
                        console.error("Delete failed:", error);
                        // Extract message from backend response (adjust path based on your backend error structure)
                        const errorMsg = error.response?.data?.message || 'Something went wrong while deleting.';
                        swal.fire({
                            title: 'Error!',
                            text: errorMsg,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            customClass: {
                                title: 'fs-6',
                                confirmButton: 'btn btn-sm btn-primary',
                            },
                        });
                    });
            } else {
                swal.fire({
                    title: 'Delete Cancelled',
                    text: `${name} was not deleted.`,
                    icon: 'info',
                    confirmButtonText: 'OK',
                    customClass: {
                        title: 'fs-6',
                        confirmButton: 'btn btn-sm btn-primary',
                    },
                });
            }
        });
    };

    const handleStatusChange = (subcategoryId, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;

        axios.put(`${baseURL}/item-subcategories/status/${subcategoryId}`, { status: newStatus })
            .then(() => {
                fetchCategories();
                toast.success("Status Updated Successfully!");
            })
            .catch(error => {
                console.log("Error updating status:", error);
                toast.error("Status Updation Failed");
            });
    };

    useEffect(() => {
        if (itemSubCategories.length > 0 && tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    responsive: true,
                    ordering: false,
                    pageLength: 25,
                    language: {
                        lengthMenu: "Show&nbsp;&nbsp; _MENU_",
                    },
                    dom: "<'row'<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l><'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>><'table-responsive'tr><'row'<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i><'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>>"
                });
            }
        }
    }, [itemSubCategories]);

    const [itemcategoryCount, setItemCategoryCount] = useState(0); // used for item category count
    const [itemsubcategoryCount, setItemSubCategoryCount] = useState(0);  // used for item sub category data
    const [itemCount, setItemCount] = useState(0);
    const [itemScheduleCount, setItemScheduleCount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/manage-items`)
            .then(response => {
                const data = response.data;

                if(data.pagination){
                    setItemCount(data.pagination?.total);
                } else {
                    setItemCount(0);
                }

            })
            .catch(error => {
                console.error("Error fetching item categories:", error);
                // setProductCategories([]);  // Default to an empty list in case of error
                setItemCount(0);  // Default to 0 in case of error
            });
    }, []);  // Only run once on mount

    useEffect(() => {
        axios.get(`${baseURL}/item-categories`)
            .then(response => {
                const data = response.data;

                if(data.pagination){
                    setItemCategoryCount(data.pagination?.total);
                } else {
                    setItemCategoryCount(0);
                }

            })
            .catch(error => {
                console.error("Error fetching item categories:", error);
                // setProductCategories([]);  // Default to an empty list in case of error
                setItemCategoryCount(0);  // Default to 0 in case of error
            });
    }, []);  // Only run once on mount

    useEffect(() => {
        axios.get(`${baseURL}/item-subcategories`)
            .then(response => {
                const data = response.data;

                if(data.pagination){
                    setItemSubCategoryCount(data.pagination?.total);
                } else {
                    setItemSubCategoryCount(0);
                }

            })
            .catch(error => {
                console.error("Error fetching item sub categories:", error);
                // setProductCategories([]);  // Default to an empty list in case of error
                setItemSubCategoryCount(0);  // Default to 0 in case of error
            });
    }, []);  // Only run once on mount

    useEffect(() => {
        axios.get(`${baseURL}/item-schedule`)
            .then(response => {
                const data = response.data;

                // Check if the response contains product categories correctly
                if (Array.isArray(data)) {
                    // setProductCategories(data);  // Set the product categories list
                    setItemScheduleCount(data.length);  // Set category count based on the array length
                } else if (Array.isArray(data?.data)) {
                    // setProductCategories(data.data);  // Set product categories if nested in 'data'
                    setItemScheduleCount(data.data.length);  // Set category count based on the nested array
                } else {
                    console.warn("Unexpected response format for schedule:", data);
                    // setProductCategories([]);  // Default to an empty list
                    setItemScheduleCount(0);  // Default to 0 in case of unexpected response
                }
            })
            .catch(error => {
                console.error("Error fetching item schedule:", error);
                // setProductCategories([]);  // Default to an empty list in case of error
                setItemScheduleCount(0);  // Default to 0 in case of error
            });
    }, []);  // Only run once on mount


    const handleAddSuccess = () => {
        console.log("Add success called!");
        toast.success("Item Sub Category added successfully!");
        setOpen(false);
        softRefresh();
    };

    const [languages, setLanguages] = useState([]);  // Store languages 
    const [languageCode, setLanguageCode] = useState();
    useEffect(() => {
        axios
            .get(`${baseURL}/language/active/list`) // API endpoint to fetch active languages
            .then((response) => {
                // Assuming response.data.data is an array of languages
                setLanguages(response.data.data || []);
            })
            .catch((error) => {
                console.error("Error fetching languages:", error);
            });
    }, []);

    const handleLanguageChange = (newLangCode) => {
        setLanguageCode(newLangCode); // Set the selected language code

        // Fetch categories based on new language code
        axios
            .get(`${baseURL}/item-subcategories`, {
                params: {
                    language_code: newLangCode,
                },
            })
            .then((response) => {
                setItemSubCategories(response.data.data || []);
                setHasFetched(true);
            })
            .catch((error) => {
                console.error(`Error fetching item categories with language_code=${newLangCode}:`, error);
            });
    };

    const [key, setKey] = useState('item_sub_cat');
    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Manage Items</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Package Management</li>
                    </ol>
                </div>

                <div className='d-flex align-items-center gap-3 mb-2'>

                    <Dropdown>
                        <Dropdown.Toggle
                            as="button"
                            variant="primary"
                            className="btn btn-primary text-white btn-sm"
                            id="tp-btn"
                        >
                            <span className="me-2">
                                <i className="fa-solid fa-globe mt-1 fs-3 px-0 py-0"></i>
                            </span>
                            {languages.find((lang) => lang.language_code === languageCode)?.language_name}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {languages.map((lang) => (
                                <Dropdown.Item
                                    key={lang.language_code}
                                    href="#"
                                    className="px-0 py-2"
                                    onClick={() => handleLanguageChange(lang.language_code)}
                                >
                                    <span className="fs-7 ms-2 font-w500 text-black">{lang.language_name}</span>
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>

                </div>


                {/* Add Modal */}
                {open && modalType === "Add" && (
                    <Add show={open} onClose={() => setOpen(false)} onSuccess={handleAddSuccess} />
                )}

                {/* ✅ Fixed Edit Modal */}
                {open && modalType === "Edit" && (
                    <Edit
                        show={open}
                        onClose={() => setOpen(false)}
                        itemId={selectedSubcategoryId} // ✅ FIXED: was subcategoryId
                        onUpdated={fetchCategories}     // ✅ Optional: refresh list after update
                    />
                )}
            </div>

            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs mb-4">
                            <Nav.Item as="li" >
                                <Nav.Link >
                                    <Link to="/manage-items" className="d-flex align-items-center text-decoration-none">
                                        <i className="fa-solid fa-bowl-rice me-3" />
                                        <label className="fs-6">
                                            Items
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                            {String(itemCount).padStart(2, '0')}
                                        </Badge>
                                    </Link>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link >
                                    <Link to="/item-category" className="d-flex align-items-center text-decoration-none">
                                        <i className="fa-solid fa-kitchen-set me-3" />
                                        <label className="fs-6">
                                            Item Category
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                            {String(itemcategoryCount).padStart(2, '0')}
                                        </Badge>
                                    </Link>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="item_sub_cat">
                                    <Link to="/item-sub-category" className="d-flex align-items-center text-decoration-none">
                                        <i className="fa-solid fa-plate-wheat me-3" />
                                        <label className="fs-6">
                                            Item Sub Category
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                            {String(itemsubcategoryCount).padStart(2, '0')}
                                        </Badge>
                                    </Link>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link >
                                    <Link to="/item-schedule" className="d-flex align-items-center text-decoration-none">
                                        <svg className="me-2" width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 8V12L14.5 14.5" stroke="#025d3a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" stroke="#025d3a" stroke-width="1.5"></path> </g></svg>
                                        <label className="fs-6">
                                            Item Schedule
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                            {String(itemScheduleCount).padStart(2, '0')}
                                        </Badge>
                                    </Link>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content className="pt-4">
                            <Tab.Pane eventKey="item_sub_cat">
                                <Row>
                                    <Col xl={12} className='mb-3 d-flex align-items-end justify-content-end gap-3'>
                                        <Link to={"#"} className="btn btn-primary float-end btn-sm mb-2" onClick={handleModalToggle}>
                                            <span className='me-2'><i className="fa-solid fa-plus fs-8"></i></span>
                                            <span>Add Item Sub Category</span>
                                        </Link>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="table-container">

                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                {/* Left: Show entries dropdown */}
                                                <div>
                                                    <label className="me-2">Show</label>
                                                    <select
                                                        className="form-select d-inline w-auto"
                                                        style={{ fontSize: '0.85rem', height: '30px' }}
                                                        value={perPage}
                                                        onChange={(e) => {
                                                            setPerPage(Number(e.target.value));
                                                            setPage(1); // Reset to first page
                                                        }}
                                                    >
                                                        <option value={25}>25</option>
                                                        <option value={50}>50</option>
                                                        <option value={75}>75</option>
                                                        <option value={100}>100</option>
                                                    </select>
                                                </div>

                                                {/* Right: Search input */}
                                                <div>
                                                    <input
                                                        type="text"
                                                        style={{ fontSize: '0.85rem', height: '40px' }}
                                                        placeholder="Search..."
                                                        className="form-control"
                                                        value={searchTerm}
                                                        onChange={(e) => {
                                                            setSearchTerm(e.target.value);
                                                            setPage(1); // Reset page on new search
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <table id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd', overflowX: 'scroll' }}>
                                                <thead>
                                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                        <th className='min-w-50px text-start'>S.No</th>
                                                        <th className='min-w-150px'>Item Sub Category</th>
                                                        <th className='min-w-150px'>Item Category</th>
                                                        <th className='min-w-100px text-center'>Item Count</th>
                                                        <th className='min-w-200px'>Description</th>
                                                        <th className='min-w-100px'>Status</th>
                                                        <th className='min-w-100px'>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-gray-600 fw-semibold fs-7">
                                                    {itemSubCategories.map((subcategory, idx) => (
                                                        <tr key={subcategory.sno}>
                                                            <td className='text-start'>
                                                                <label className='text-black font-w400 fs-7'>{idx + 1}</label>
                                                            </td>
                                                            <td><label className='text-black font-w400 fs-7'>{subcategory.itemsubcategory_name}</label></td>
                                                            <td><label className='text-black font-w400 fs-7'>{subcategory.itemcategory_name}</label></td>
                                                            <td className='text-center'>
                                                                {subcategory.item_count > 0 ? (
                                                                    <Badge bg="success" className='text-white fs-7 py-0 px-2'>
                                                                        {subcategory.item_count}
                                                                    </Badge>
                                                                ) : (
                                                                    '-'
                                                                )}
                                                            </td>

                                                            <td>
                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={
                                                                    <Tooltip className='toltip-popover'>
                                                                        <span className='fs-8 text-white fw-semibold'>
                                                                            {subcategory.description || "No description available."}
                                                                        </span>
                                                                    </Tooltip>
                                                                }>
                                                                    <div className='text-truncate mw-250px text-black font-w400 fs-7'>
                                                                        {subcategory.description || "No description available."}
                                                                    </div>
                                                                </OverlayTrigger>
                                                            </td>
                                                            <td>
                                                                <div className="form-check form-switch d-flex align-items-center mb-3">
                                                                    <input
                                                                        className="form-check-input me-2"
                                                                        type="checkbox"
                                                                        role="switch"
                                                                        checked={subcategory.status === 0}
                                                                        onChange={() => handleStatusChange(subcategory.sno, subcategory.status)}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>

                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>}>
                                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalItemSub_Edit(subcategory.sno)}>
                                                                        <i className="fa-solid fa-pen-to-square fs-6"></i>
                                                                    </Button>
                                                                </OverlayTrigger>

                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={
                                                                    <Tooltip className='toltip-popover'>
                                                                        <span className='fs-8 text-white fw-semibold'>Delete</span>
                                                                    </Tooltip>
                                                                }>
                                                                    <Button
                                                                        variant="primary tp-btn-light px-2 py-1 me-1"
                                                                        onClick={() => DeleteModal(subcategory.sno, subcategory.itemsubcategory_name, fetchCategories)}
                                                                    >
                                                                        <i className="fa-solid fa-trash-can fs-6 mt-1"></i>
                                                                    </Button>
                                                                </OverlayTrigger>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>

                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                {/* Bottom left: Showing x to y of z entries */}
                                                <div>
                                                    {itemSubCategories.length > 0 && (
                                                        <span className="text-muted">
                                                            Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + itemSubCategories.length} of {totalEntries} entries
                                                        </span>
                                                    )}
                                                </div>


                                                {/* Bottom right: Pagination */}
                                                <nav>
                                                    <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                                        </li>
                                                        {[...Array(totalPages)].map((_, i) => (
                                                            <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                                            </li>
                                                        ))}
                                                        <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                                        </li>
                                                    </ul>
                                                </nav>

                                            </div>

                                            <EditItemSubCat
                                                show={editModalShow}
                                                onClose={() => setEditModalShow(false)}
                                                itemSubId={currentItemId}  // Pass the actual id here
                                                onUpdated={fetchCategories}
                                            />

                                        </div>
                                    </Col>
                                </Row>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col>
        </>
    );
}

export default ItemSubCategory;
